module.exports = __webpack_public_path__ + "static/media/kybComplete1.66416e28.png";